<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示：</div>
      <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
      <div class="no">
        2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
      </div>
      <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
      <div class="no">
        4.智绘网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </div>
    </div>
    <div>
      <navStepList
        style="justify-content: center; margin: 40px 0"
        :value="navStepList"
        :current="navStepCurrent"
        :lineWidth="40"
      ></navStepList>
    </div>
    <template v-if="navStepCurrent === 0">
      <div>
        <div class="condition-section">
          <div class="cond-row">
            <div class="item">
              <div style="margin-right: 10px">发票类型：</div>
              <Select
                class="height45"
                v-model="searchObj.invoiceType"
                style="width: 180px"
                clearable
              >
                <Option
                  v-for="item in invoiceTypeLists"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </div>
            <div class="item">
              <div style="margin-right: 10px">交易时间：</div>
              <DatePicker
                class="height45"
                v-model="searchObj.startAtStr"
                format="yyyy-MM-dd"
                type="daterange"
                placement="bottom-end"
                placeholder="交易时间"
                style="width: 240px"
                @on-change="onStartAtChange"
              ></DatePicker>
            </div>
            <div class="item" style="margin-right: 60px">
              <div style="margin-right: 10px">可开票金额：</div>
              <Input
                class="height45"
                v-model="searchObj.startMoney"
                placeholder="开始可开票金额"
                style="width: 100px"
                @on-keyup="
                  searchObj.startMoney = searchObj.startMoney.replace(
                    /[^\d^\.]+/g,
                    ''
                  )
                "
                clearable
              />
              <span>-</span>
              <Input
                class="height45"
                v-model="searchObj.endMoney"
                placeholder="结束可开票金额"
                @on-keyup="
                  searchObj.endMoney = searchObj.endMoney.replace(
                    /[^\d^\.]+/g,
                    ''
                  )
                "
                style="width: 100px"
                clearable
              />
            </div>
            <div class="item">
              <Button
                class="btn-height45"
                type="primary"
                style="margin-right: 20px"
                @click="onSearch"
                >搜索</Button
              >
              <Button class="btn-height45" @click="onSearchCancel">重置</Button>
            </div>
          </div>
          <div class="lb-section">
            <div class="lb-main">
              <div style="flex: 1; display: flex">
                <div class="item item-border">
                  <span class="count">{{ availableAmount }}</span>
                  <span>可开票金额</span>
                </div>
                <div class="item item-border">
                  <span class="count">{{ totalInvoiceAmount }}</span>
                  <span>开票金额</span>
                </div>
                <div class="item">
                  <span class="count">{{ usedAmount }}</span>
                  <span>已开票金额</span>
                </div>
              </div>
              <div class="item">
                <span style="margin-bottom: 20px"
                  >已选开票金额: {{ selectTotal }}</span
                >
                <Button
                  shape="circle"
                  class="btn-height45"
                  style="width: 100px"
                  @click="onAdd"
                  >申请发票</Button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="table-data">
          <div class="total rows">
            <span>搜索结果（{{ searchObj.total }}）</span>
            <div class="rows ml-20">
              <div
                :class="['nav mr-20', { navActive: searchObj.timeType === 0 }]"
                @click="selectNav(0)"
              >
                本月可开
              </div>
              <div
                :class="['nav mr-20', { navActive: searchObj.timeType === 1 }]"
                @click="selectNav(1)"
              >
                下月可开
              </div>
              <div
                :class="['nav', { navActive: searchObj.timeType === 2 }]"
                @click="selectNav(2)"
              >
                已开票记录
              </div>
            </div>
          </div>
          <Table
            class="domain-table"
            :columns="columns"
            :data="data"
            :loading="tableLoading"
            @on-selection-change="onSelectionChange"
          >
            <template slot="remark" slot-scope="{ row }">
              <Button  @click="onShowRemark(row.remark)">查看备注</Button>
            </template>
          </Table>
          <div class="page-tool">
            <Page
              :current="searchObj.page"
              :total="searchObj.total"
              :page-size="searchObj.limit"
              @on-change="onPageChange"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="navStepCurrent === 1">
      <div class="tips-section">
        <div class="rows tj">
          <div>
            您选取了<span class="color-3992e9">{{selectList.length}}</span>条单据开具发票
            (若选中多条记录，金额将合并开具在一张票据中)
          </div>
          <div>已选开票金额： <span class="color-3992e9">￥{{selectTotal}}</span></div>
        </div>
        <div class="d-table">
          <div class="d-item">
            <div class="d-item-name required">发票信息</div>
            <div class="d-item-value">
              <Select
                class="height45"
                v-model="form.invoiceId"
                filterable
                style="width: 250px"
                placeholder="请选择"
                @on-change="infoChange"
              >
                <Option
                  v-for="item in invoiceInfoList"
                  :key="item.id"
                  :value="item.id"
                  >{{
                    `${item.title} - ${
                      item.issueType == 0 ? "个人" : "企业"
                    } - ${
                      item.invoiceType == 0
                        ? "增值税普通发票"
                        : "增值税专用发票"
                    }`
                  }}</Option
                >
              </Select>
            </div>
          </div>
          <template v-if="form.invoiceId">
            <div class="d-item">
              <div class="d-item-name required">开具类型</div>
              <div class="d-item-value">
                <RadioGroup v-model="invoiceInfoType.issueType">
                  <Radio :label="0" disabled>个人</Radio>
                  <Radio :label="1" disabled>企业</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="d-item">
              <div class="d-item-name required">发票类型</div>
              <div class="d-item-value">
                <RadioGroup v-model="invoiceInfoType.invoiceType">
                  <Radio :label="0" disabled>个人</Radio>
                  <Radio :label="1" disabled>企业</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="d-item">
              <div class="d-item-name required">发票抬头</div>
              <div class="d-item-value">
                <Input
                  class="height45"
                  disabled
                  v-model="form.title"
                  placeholder="发票抬头"
                  style="width: 300px"
                  clearable
                />
              </div>
            </div>
          </template>
          <div class="d-item">
            <div class="d-item-name required">发票内容</div>
            <div class="d-item-value">
              <RadioGroup v-model="form.contentType">
                <Radio :label="0">域名服务费</Radio>
                <Radio :label="1">信息服务费</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">收件人</div>
            <div class="d-item-value">
              <Input
                class="height45"
                v-model="form.recipient"
                placeholder="收件人"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">手机号码</div>
            <div class="d-item-value">
              <Input
                class="height45"
                v-model="form.mobile"
                placeholder="手机号码"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name required">收件人地址</div>
            <div class="d-item-value">
              <Input
                class="height45"
                v-model="form.address"
                placeholder="收件人地址"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name">邮编</div>
            <div class="d-item-value">
              <Input
                class="height45"
                v-model="form.postcode"
                placeholder="邮编"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
          <div class="d-item">
            <div class="d-item-name">备注</div>
            <div class="d-item-value">
              <Input
                class="height45"
                v-model="form.remark"
                placeholder="备注"
                style="width: 300px"
                clearable
              />
            </div>
          </div>
        </div>
        <div class="rows" style="margin-left: 20px">
          <RadioGroup v-model="form.expressPaymentType">
            <Radio
              :label="0"
              :disabled="$store.state.balance < (form.expressAmount || 0)"
              >快递{{ form.expressAmount || 0 }}元（当前可用余额：{{
                $store.state.balance || 0
              }}元)</Radio
            >
            <Radio :label="1" style="margin-left: 20px">到付（顺丰）</Radio>
          </RadioGroup>
        </div>
        <div class="rows" style="margin-top: 20px; margin-left: 20px">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onConfirm"
            >提交申请</Button
          >
          <Button class="btn-height45" @click="backCancel">返回上一步</Button>
          <Checkbox v-model="form.isDefault" style="margin-left: 20px">
            设置默认信息</Checkbox
          >
        </div>
      </div>
    </template>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
  </div>
</template>

<script>
import navStepList from "components/navStepList";
import {
  invoiceTypeList,
  invoiceInvoiceAmountList,
  invoiceTotalInvoiceAmount,
  invoiceDefault,
  invoiceInfoMore,
  applyMakeInvoice,
} from "api/user.js";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
export default {
  name: "invoiceapply",
  components: {
    navStepList,
    pushRemarkModal,
  },
  data() {
    return {
      navStepList: [
        "选择开票订单",
        "填写发票信息和地址",
        "后台审核，邮寄发票",
        "签收快递，开票成功",
      ],
      invoiceTypeLists: [],
      navStepCurrent: 0,
      searchObj: {
        startAtStr: [],
        endAt: "",
        endMoney: "",
        invoiceType: null,
        limit: 20,
        page: 1,
        startAt: "",
        startMoney: "",
        timeType: 0,
      },
      columns: [
        {
          type: "selection",
          align: "center",
        },
        {
          title: "申请时间",
          key: "createdAt",
          align: "center",
        },
        {
          title: "类型",
          key: "typeName",
          align: "center",
        },
        {
          title: "交易金额",
          key: "transactionAmount",
          align: "center",
        },
        {
          title: "可开票金额",
          key: "availableAmount",
          align: "center",
        },
        {
          title: "备注",
          ellipsis: true,
          slot: "remark",
          align: "center",
        },
      ],
      availableAmount: "",
      totalInvoiceAmount: "",
      usedAmount: "",
      selectTotal: "",
      data: [],
      tableLoading: false,
      pushRemarkModalVisibility: false,
      remark: "", // 备注内容
      defaultDetail: {}, // 默认发票
      invoiceInfoList: [], // 发票信息查询全部
      form: {
        invoiceId: "",
        title: "",
        contentType: 0,
        recipient: "",
        mobile: "",
        address: "",
        postcode: "",
        remark: "",
        isDefault: false,
        expressPaymentType: 0,
        expressAmount: null,
      },
      selectList: [], // 选中的域名
    };
  },
  computed: {
    invoiceInfoType() {
      for (const i in this.invoiceInfoList) {
        if (this.invoiceInfoList[i].id === this.form.invoiceId) {
          return {
            issueType: this.invoiceInfoList[i].issueType,
            invoiceType: this.invoiceInfoList[i].invoiceType,
          };
        }
      }
      return {
        issueType: null,
        invoiceType: null,
      };
    },
  },
  created() {
    this.req_invoiceTypeList();
    this.req_invoiceTotalInvoiceAmount();
    this.req_getList();
  },
  methods: {
    // 请求类型
    async req_invoiceTypeList() {
      const { code, data } = await invoiceTypeList();
      if (code === 200) {
        let tempArray = data.map((o) => {
          return { value: o.invoiceType, label: o.typeName };
        });
        this.invoiceTypeLists = tempArray || [];
      }
    },
    // 获取发票总金额
    async req_invoiceTotalInvoiceAmount() {
      const { code, data } = await invoiceTotalInvoiceAmount();
      if (code === 200) {
        this.availableAmount = data.availableAmount || 0;
        this.totalInvoiceAmount = data.totalInvoiceAmount || 0;
        this.usedAmount = data.usedAmount || 0;
      }
    },
    // 默认发票
    async req_invoiceDefault() {
      const { code, data, result } = await invoiceDefault();
      if (code === 200 && data != null && result) {
        if (data.invoiceId) {
          this.form.invoiceId = data.invoiceId;
          this.form.title = data.title;
          this.form.contentType = data.contentType;
          this.form.recipient = data.recipient;
          this.form.mobile = data.mobile;
          this.form.address = data.address;
          this.form.postcode = data.postcode;
          this.form.isDefault = data.isDefault;
        }
        this.form.expressAmount = data.expressAmount;
      }
    },
    // 发票信息查询全部
    async req_invoiceInfoMore() {
      const { code, data } = await invoiceInfoMore();
      if (code === 200) {
        this.invoiceInfoList = data;
      }
    },
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          endAt: this.searchObj.endAt,
          startAt: this.searchObj.startAt,
          endMoney: "",
          startMoney: "",
        };
        this.searchObj.invoiceType !== -1 &&
          (params.invoiceType = this.searchObj.invoiceType);
        this.tableLoading = true;
        const { code, data } = await invoiceInvoiceAmountList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 申请发票
    async req_applyMakeInvoice() {
      const params = {
        ids: this.selectList.map((item) => item.id),
        invoiceId: this.form.invoiceId,
        title: this.form.title,
        contentType: this.form.contentType,
        recipient: this.form.recipient,
        mobile: this.form.mobile,
        address: this.form.address,
        postcode: this.form.postcode,
        remark: this.form.remark,
        isDefault: this.form.isDefault ? 1 : 0,
        expressPaymentType: this.form.expressPaymentType,
        expressAmount: this.form.expressAmount,
      };
      const { code, result } = await applyMakeInvoice(params);
      if (code === 200 && result) {
        this.$Message.success("申请提交成功，您的申请将在后台审核！");
        this.form = this.$options.data().form;
        this.navStepCurrent = 0;
      }
    },
    // 提交申请
    onConfirm() {
      if (this.selectList.length <= 0) {
        this.$Message.warning("请选择开票订单！");
        this.active = 1;
        this.clearAll();
        return;
      }
      if (!this.form.invoiceId) {
        this.$Message.warning("请输入选择发票信息！");
        return;
      }
      if (!this.form.recipient) {
        this.$Message.warning("请输入收件人！");
        return;
      }
      if (!this.form.mobile) {
        this.$Message.warning("请输入手机号码！");
        return;
      }
      if (!this.form.address) {
        this.$Message.warning("请输入收件人地址！");
        return;
      }
      this.req_applyMakeInvoice();
    },
    // 返回上一步
    backCancel() {
      this.form = this.$options.data().form;
      this.navStepCurrent = 0;
      this.onPageChange(1);
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 日期改变
    onStartAtChange(event) {
      this.searchObj.startAt = event[0];
      this.searchObj.endAt = event[1];
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
    // 申请发票
    onAdd() {
      if (!this.selectList || this.selectList.length <= 0) {
        this.$Message.warning("您未选择任何可开发票！");
        return;
      }
      this.req_invoiceInfoMore();
      this.req_invoiceDefault();
      this.navStepCurrent = 1;
    },
    // 开票类型
    selectNav(val) {
      this.searchObj.timeType = val;
      this.onPageChange(1);
    },
    // 发票信息选择改变
    infoChange() {
      for (const i in this.invoiceInfoList) {
        if (this.invoiceInfoList[i].id === this.form.invoiceId) {
          this.form.title = this.invoiceInfoList[i].title;
          return;
        }
      }
    },
    // 选中
    onSelectionChange(val) {
      this.selectList = val;
      this.selectTotal = val.reduce((pre, nextVal) => {
        return pre + nextVal.availableAmount || 0;
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.tips-section {
  padding: 30px 50px 30px;
  background-color: #fff;
  border-radius: 8px;
  .title {
    color: #333333;
    font-size: 14px;
    font-weight: Bold;
    line-height: 36px;
  }
  .no {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
  }
}
.lb-section {
  margin-top: 20px;
  padding: 50px 0;
  background-color: #f0f3f6;
}
.lb-main {
  display: flex;
  justify-content: space-between;
  .item {
    flex: 0 1 266px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      color: #333;
    }
    .count {
      margin-bottom: 20px;
      line-height: 1;
      color: #3992e9;
      font-size: 48px;
      font-weight: bold;
    }
  }
  .item-border {
    border-right: 1px solid #4343442e;
  }
}
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
.rows {
  display: flex;
  align-items: center;
}

.nav {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 24px;
  cursor: pointer;
}
.ml-20 {
  margin-left: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.navActive {
  color: #3992e9;
}
.tj {
  justify-content: space-between;
  background-color: #f0f3f6;
  padding: 30px 60px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  line-height: 60px;
}
.color-3992e9 {
  color: #3992e9;
}
.d-table {
  width: 100%;
  background-color: #fff;
  padding: 0px 20px 20px;
  .d-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
  }
  .d-item-name {
    width: 205px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-weight: bold;
    color: #333333;
    border-right: 1px solid #e8e8e8;
  }
  .d-item-name.required {
    &::before {
      content: "*";
      margin-right: 10px;
      color: #ff5c35;
    }
  }
  .d-item-value {
    display: flex;
    align-items: center;
    margin-left: 60px;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
